/**
 * One row from `order_status_timeline` — every accepted Lifecycle transition,
 * newest first (backend `getOrderTimeline`).
 */
export interface RawTimelineEntry {
  from_status?: string;
  to_status: string;
  channel_state?: string;
  trigger: string;
  source: string;
  actor: string;
  stock_effect: string;
  occurred_at: string;
}

export interface TimelineLogEntry {
  fromStatus: string | null;
  toStatus: string;
  channelState: string | null;
  trigger: string;
  source: string;
  actor: string;
  stockEffect: string;
  occurredAt: string;
}

export function toTimelineLogEntry(raw: RawTimelineEntry): TimelineLogEntry {
  return {
    fromStatus: raw.from_status ?? null,
    toStatus: raw.to_status,
    channelState: raw.channel_state ?? null,
    trigger: raw.trigger,
    source: raw.source,
    actor: raw.actor,
    stockEffect: raw.stock_effect,
    occurredAt: raw.occurred_at,
  };
}
